"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOriginalOfferDtoActionTypeEnum = exports.GetOriginalOfferDtoActionMadeByEnum = void 0;
exports.instanceOfGetOriginalOfferDto = instanceOfGetOriginalOfferDto;
exports.GetOriginalOfferDtoFromJSON = GetOriginalOfferDtoFromJSON;
exports.GetOriginalOfferDtoFromJSONTyped = GetOriginalOfferDtoFromJSONTyped;
exports.GetOriginalOfferDtoToJSON = GetOriginalOfferDtoToJSON;
exports.GetOriginalOfferDtoToJSONTyped = GetOriginalOfferDtoToJSONTyped;
/**
 * @export
 */
exports.GetOriginalOfferDtoActionMadeByEnum = {
    Vendor: 'vendor',
    Admin: 'admin',
    Agent: 'agent',
    Buyer: 'buyer'
};
/**
 * @export
 */
exports.GetOriginalOfferDtoActionTypeEnum = {
    Accept: 'accept',
    Reject: 'reject',
    Counter: 'counter',
    Reserve: 'reserve'
};
/**
 * Check if a given object implements the GetOriginalOfferDto interface.
 */
function instanceOfGetOriginalOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function GetOriginalOfferDtoFromJSON(json) {
    return GetOriginalOfferDtoFromJSONTyped(json, false);
}
function GetOriginalOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'offerPrice': json['offerPrice'],
        'actionMadeBy': json['actionMadeBy'] == null ? undefined : json['actionMadeBy'],
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
    };
}
function GetOriginalOfferDtoToJSON(json) {
    return GetOriginalOfferDtoToJSONTyped(json, false);
}
function GetOriginalOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'depositAmount': value['depositAmount'],
        'offerPrice': value['offerPrice'],
        'actionMadeBy': value['actionMadeBy'],
        'actionType': value['actionType'],
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
        'settlementDate': value['settlementDate'],
    };
}
